import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

export const ContactUs = () => {
  const form = useRef();
  const [status, setStatus] = useState("");

  const sendEmail = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      await emailjs.sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        "template_4rhd7m9",
        form.current,
        "XEj_WhQjKwGc7Nnyq",
      );
      setStatus("sent");
      form.current.reset();
    } catch (error) {
      console.error("Email sending failed:", error);
      setStatus("error");
    }
  };

  const fieldClass =
    "w-full border-b border-primary/25 bg-transparent py-3 font-body text-base text-primary placeholder:text-primary/30 focus:border-accent focus:outline-none";
  const labelClass =
    "font-body text-2xs font-medium uppercase tracking-widest text-primary/45";

  return (
    <section
      id='contact'
      className='w-full border-b border-line bg-background py-20 md:py-28'
    >
      <div className='swiss-container'>
        <div className='flex items-baseline gap-4 border-t border-line pt-4'>
          <span className='font-body text-sm font-medium tabular-nums text-primary/45'>
            05
          </span>
          <span className='font-body text-2xs font-medium uppercase tracking-widest text-primary/55'>
            Contact
          </span>
        </div>

        <div className='mt-16 grid grid-cols-1 gap-x-10 gap-y-12 lg:grid-cols-12'>
          {/* Left — invitation */}
          <div className='lg:col-span-5'>
            <h2 className='font-heading text-3xl font-extrabold uppercase leading-[0.95] tracking-tighter text-primary sm:text-4xl md:text-5xl'>
              Let's
              <br />
              <span className='text-primary/55'>work together</span>
            </h2>
            <p className='mt-8 max-w-sm font-body text-base leading-relaxed text-primary/60'>
              Open to opportunities and collaborations. Send a message and I'll
              respond promptly.
            </p>

            <div className='mt-10 space-y-4 border-t border-line pt-8'>
              <a
                href='mailto:zinmyowin0567@gmail.com'
                className='block font-body text-sm text-primary/70 transition-colors hover:text-accent'
              >
                zinmyowin0567@gmail.com
              </a>
              <a
                href='https://www.linkedin.com/in/zin-myo-win/'
                target='_blank'
                rel='noopener noreferrer'
                className='block font-body text-sm text-primary/70 transition-colors hover:text-accent'
              >
                linkedin.com/in/zin-myo-win
              </a>
              <a
                href='https://github.com/ZinMyoWin'
                target='_blank'
                rel='noopener noreferrer'
                className='block font-body text-sm text-primary/70 transition-colors hover:text-accent'
              >
                github.com/ZinMyoWin
              </a>
            </div>
          </div>

          {/* Right — form */}
          <form
            ref={form}
            onSubmit={sendEmail}
            className='flex flex-col gap-8 lg:col-span-6 lg:col-start-7'
          >
            <div className='grid grid-cols-1 gap-8 sm:grid-cols-2'>
              <div className='flex flex-col gap-3'>
                <label htmlFor='from_name' className={labelClass}>
                  Name
                </label>
                <input
                  id='from_name'
                  name='from_name'
                  type='text'
                  placeholder='Your name'
                  className={fieldClass}
                  required
                />
              </div>
              <div className='flex flex-col gap-3'>
                <label htmlFor='reply_to' className={labelClass}>
                  Email
                </label>
                <input
                  id='reply_to'
                  name='reply_to'
                  type='email'
                  placeholder='you@email.com'
                  className={fieldClass}
                  required
                />
              </div>
            </div>

            <div className='flex flex-col gap-3'>
              <label htmlFor='message' className={labelClass}>
                Message
              </label>
              <textarea
                id='message'
                name='message'
                rows={4}
                placeholder='Tell me about your project…'
                className={`${fieldClass} resize-none`}
                required
              />
            </div>

            <div className='flex flex-wrap items-center gap-6'>
              <button
                type='submit'
                disabled={status === "sending"}
                className='bg-primary px-8 py-4 font-body text-xs font-semibold uppercase tracking-wider text-background transition-colors hover:bg-accent hover:text-white disabled:opacity-50'
              >
                {status === "sending" ? "Sending…" : "Send message"}
              </button>
              {status === "sent" && (
                <span className='font-body text-2xs font-medium uppercase tracking-widest text-accent'>
                  Message sent thank you
                </span>
              )}
              {status === "error" && (
                <span className='font-body text-2xs font-medium uppercase tracking-widest text-primary/50'>
                  Failed please try again
                </span>
              )}
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};
